import { render, staticRenderFns } from "./tc-video.vue?vue&type=template&id=6f511d2d"
import script from "./tc-video.vue?vue&type=script&lang=js"
export * from "./tc-video.vue?vue&type=script&lang=js"
import style0 from "./tc-video.vue?vue&type=style&index=0&id=6f511d2d&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f511d2d')) {
      api.createRecord('6f511d2d', component.options)
    } else {
      api.reload('6f511d2d', component.options)
    }
    module.hot.accept("./tc-video.vue?vue&type=template&id=6f511d2d", function () {
      api.rerender('6f511d2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tc-video.vue"
export default component.exports